import React from "react";
import { Link } from "react-router-dom";
import useVerificationCodeForm from "../../Hooks/VerificationHook";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { useNavigate } from "react-router-dom";
import "./Accountverification.css";

const Acountverification = () => {
  const navigate = useNavigate()
  const {
    verificationCode,
    handleChange,
    handleSubmit,
    isLoading,
    isLoading2,
    error,
    resendTimer,
    handleResend,
    inputRefs,
    handlePaste,
  } = useVerificationCodeForm();

  return (
    <div className="account-verification">
      <div className="content-card">
        <div className="wrap">
          <BlackVatugIcon onClick={() => navigate("/")} />
          <Link to="/Login">Back</Link>
        </div>
        <form>
          <h3>Verify Email Address</h3>
          <p>Enter 6-digit code sent to your Email</p>

          <div className="cube-box">
            {verificationCode.map((digit, index) => (
              <input
                ref={(el) => (inputRefs.current[index] = el)}
                key={index}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(event) => handleChange(index, event.target.value)}
                onPaste={index === 0 ? handlePaste : null}
                onKeyDown={(event) => {
                  if (event.key === "Backspace" && digit === "") {
                    if (index > 0) {
                      inputRefs.current[index - 1]?.focus();
                    }
                  }
                }}
              />
            ))}
          </div>

          {error && <div className="error">{error}</div>}
          <button onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? "Verifying..." : "Continue"}
          </button>
          <p>
            Didnt get the code?,{" "}
            <span onClick={handleResend} disabled={resendTimer > 0}>
              {isLoading2 ? "Sending..." : " Resend"}
            </span>{" "}
            {resendTimer > 0 && `in ${resendTimer}s`}
          </p>
        </form>
      </div>
      <div className="img"></div>
    </div>
  );
};

export default Acountverification;
